import { Input } from "@ttc3k/trekker";
import { TagManyQuery } from "gql/generated";
import { Label } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { WhereaboutsModal } from "shared/components";
import { getMultilingualString } from "shared/utils";
import { useCreateEditBackOfficeTags } from "./useCreateEditBackOfficeTags";

export type CreateEditBackOfficeTagModalProps = {
  isOpen: boolean;
  onClose: () => void;
  tag: TagManyQuery["tagMany"][0] | null;
  organizationId?: string;
  tagGroupId?: string;
};

export const CreateEditBackOfficeTagModal = ({
  isOpen,
  onClose,
  tag,
  organizationId,
  tagGroupId,
}: CreateEditBackOfficeTagModalProps) => {
  const { t } = useTranslation("directory", {
    keyPrefix: "ORGANIZATION.BACK_OFFICE.TAGS",
  });
  const { onSaveTag, tagName, setTagName, onCloseModal } =
    useCreateEditBackOfficeTags({
      tag,
      tagGroupId,
      organizationId,
      onClose,
    });

  const isEditingTag = !!tag;
  const isDirty = tag
    ? getMultilingualString(tag.name) !== tagName
    : tagName.length > 0;

  return (
    <WhereaboutsModal
      isOpen={isOpen}
      onClose={onCloseModal}
      HeaderIcon={Label}
      title={isEditingTag ? t("EDIT_TAG") : t("ADD_NEW_TAG")}
      size={"sm"}
      cancelButtonProps={{ display: "none" }}
      // cancelButtonCopy={t("DELETE_TAG")}
      saveButtonCopy={t("SAVE_TAG")}
      saveButtonProps={{
        visual: "accent.blue",
        onClick: onSaveTag,
        disabled: !isDirty,
      }}
    >
      <Input
        label={t("TAG_LABEL")}
        value={tagName}
        onChange={(e) => setTagName(e.target.value)}
      />
    </WhereaboutsModal>
  );
};
